import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import {FormControl, InputLabel, FormHelperText} from '@mui/material';

const styles = (theme: Theme): StyleRules => ({
  container: {
    marginTop: 15,
    display: 'flex',
    width: '100%'
  },
  chip: {
    display: 'flex',
    border: 'solid 1px #bbb',
    borderRadius: 10,
    margin: "5px 5px 5px 0px"
  },
  key: {
    display: 'flex',
    backgroundColor: '#b5fdd8',
    borderRadius: '10px 0px 0px 10px',
    borderRight: 'solid 1px #bbb',
    padding: '5px 5px 5px 10px'
  },
  criticalKey: {
    display: 'flex',
    backgroundColor: '#fbeb9e',
    borderRadius: '10px 0px 0px 10px',
    borderRight: 'solid 1px #bbb',
    padding: '5px 5px 5px 10px'
  },
  userKey: {
    display: 'flex',
    backgroundColor: '#b5d2fd',
    borderRadius: '10px 0px 0px 10px',
    borderRight: 'solid 1px #bbb',
    padding: '5px 5px 5px 10px'
    
  },
  value: {
    display: 'flex',
    backgroundColor: '#fafafa',
    borderRadius: '0px 10px 10px 0px',
    padding: '5px 10px 5px 5px'
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  data: any;
  path: any;
  value: any;
}

type State = {};

class JsonLabel extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {};
  }

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {data, value, path, fieldDefinition} = this.props;

    if(!value){
      return null
    }

    const chips = Object.entries(value).map((i: Array<any>) => {
      const key = i[0];
      let keyClass = classes.key;
      switch(key){
        case "templateType":
          keyClass = classes.criticalKey;
        case "formType":
          keyClass = classes.criticalKey;
        case "userType":
          keyClass = classes.userKey;
      }

      const value = i[1];
      return (
        <div key={key} className={classes.chip}>
          <div className={keyClass}>{key}</div>
          <div className={classes.value}>{value}</div>
        </div>
      );
    });

    return (
      <FormControl className={classes.formDefField}>
          <InputLabel shrink>{fieldDefinition.title}</InputLabel>
        <div className={classes.container}>
          {chips}
        </div>
      </FormControl>
    );
  }
}

export default withStyles(styles)(JsonLabel);
